<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 入账编號" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >總充值：{{total_list.total}}</el-tag> -->
				<!-- 	<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">申請修改</el-button> -->
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->

				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="基础搜索" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="名稱入账编號"></el-input>
						</el-form-item>
					
						
						
						<el-form-item label="提交時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
				
				
				
			
				
				<el-table-column align="center" width="120"  prop="shop_name" label="所属店铺"></el-table-column>
				<el-table-column align="center" width="120"  prop="sad_name" label="申請店長"></el-table-column>
		
		
				<el-table-column align="center"  prop="status"  label="入账類型">
					<template slot-scope="v">
						
						
						<span class="text-warning" v-if="v.row.type==1">销售入账</span>
						<span class="text-warning" v-if="v.row.type==2">成本入账</span>
						<span class="text-warning" v-if="v.row.type==3">轉賬入账</span>
						
					</template>
				</el-table-column>
				
				
				<el-table-column width="220" align="center" prop="order_no" label="入账單號">
				</el-table-column>

				
				<el-table-column align="center" prop="remark"  label="申請原因">
			
				</el-table-column>
				
	
			
				
				<el-table-column align="center"  prop="status"  label="狀態">
					<template slot-scope="v">
						<span style="color:#999" v-if="v.row.status==0">待审核</span>
						<span class="text-success" v-if="v.row.status==1">同意修改</span>
						<span class="text-danger" v-if="v.row.status==2">拒绝修改
							
						</span>
						<el-tag v-if="v.row.status==2" type="danger">{{v.row.status_remark}}</el-tag>
						
						
						<span class="text-success" v-if="v.row.status==3">店長已修改</span>
						
					</template>
				</el-table-column>
				
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="狀態">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="提交時間">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group v-if="scope.row.status==0">
							
							
							
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="successApply(scope.row)">同意</el-button>
							
							<el-button @click="openModel(scope.row,3)"  v-auth="'delRule'" size="mini" plain type="danger">拒绝</el-button>

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'拒绝修改':'拒绝修改'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<el-form-item label="入账编號" prop="name">
					{{form.order_no}}
				</el-form-item>

				
				
				<el-form-item label="拒绝原因" prop="status_remark">
					<el-input type="textarea" :rows="6" v-model="form.status_remark" 
					placeholder="請輸入拒绝原因" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			

				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					status_remark: [{
							required: true,
							message: "請輸入拒绝原因",
							trigger: 'blur',
						},
					],
					
					
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
				
					time: [],
				},
				model_title: 'Apply',
				auth_val: 'Apply',
				preUrl: "data/ApplyList", //列表地址
				addUrl: "data/addApply", //添加/修改地址
				editStatusUrl: "data/editStatusApply", //修改狀態地址
				tableData: [],
				form: {
					id: 0,
					status:0,
					status_remark:''
					
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: []
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('rule');
		},
		methods: {
			
			successApply(e){
				this.$confirm('是否確定同意店長的修改申請, 是否继续?', '提示', {
					  confirmButtonText: '確定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					  this.form = {
					  	id:  e.id,
					  	status:1,
					  	status_remark:''
					  }
					  this.addOrEdit(this.form)
					}).catch(() => {
					       
					});
			},
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上傳头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上傳头像图片大小不能超過 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e) {
				console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						order_no:e.order_no,
						status: 2,
						status_remark: e.head,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:'',
						img:"",
						head:'',
						local:''
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
				
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
